  (() => {
      if (window.location.pathname.replace(/\/$/, '') !== '/pages/toner-pad-sale') return;
      if (window.__seyoulTonerPadQikifyFix) return;
      window.__seyoulTonerPadQikifyFix = true;

      const OFFER_BY_VARIANT = {
        '43846110216226': {
          code: 'TONER199',
          offerId: '570251',
          productId: '7974188941346',
          type: 'cart-upsell',
        },
        '43529944104994': {
          code: 'TONERCOLLAGEN199',
          offerId: '570471',
          productId: '7912804778018',
          type: 'cart-upsell',
        },
      };

      const TONER_PRODUCT_IDS = new Set(Object.values(OFFER_BY_VARIANT).map((offer) => offer.productId));
      const MIN_CART_TOTAL = 200000;

      const getVariantIdFromForm = (form) => {
        const input = form?.querySelector('[name="id"]');
        return input ? String(input.value || '').trim() : '';
      };

      const getQuantityFromForm = (form) => {
        const input = form?.querySelector('[name="quantity"]');
        const quantity = parseInt(input?.value || '1', 10);
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      };

      const setHiddenInput = (form, name, value) => {
        if (!form || !name || value == null || value === '') return;

        let input = Array.from(form.querySelectorAll('input[name]')).find((field) => field.name === name);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          form.appendChild(input);
        }

        input.value = String(value);
      };

      const fetchCart = async () => {
        const response = await fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) throw new Error('Unable to fetch cart');
        return response.json();
      };

      const isOfferLine = (item) => {
        const properties = item?.properties || {};
        return Boolean(
          properties._qbk_offer_id ||
          properties['_qbk-offer-id'] ||
          properties['_qbk-trigger-id'] ||
          properties['_qbk-tier'] ||
          TONER_PRODUCT_IDS.has(String(item?.product_id || ''))
        );
      };

      const regularSubtotal = (cart) => {
        return (cart?.items || []).reduce((total, item) => {
          if (isOfferLine(item)) return total;
          return total + Number(item.final_line_price || item.line_price || 0);
        }, 0);
      };

      const isEligibleCart = (cart) => {
        return regularSubtotal(cart) >= MIN_CART_TOTAL ||
          Number(cart?.items_subtotal_price || 0) >= MIN_CART_TOTAL ||
          Number(cart?.total_price || 0) >= MIN_CART_TOTAL;
      };

      const findTriggerItem = (cart) => {
        return (cart?.items || []).find((item) => !isOfferLine(item));
      };

      const getCartSignature = (cart) => {
        return JSON.stringify({
          item_count: cart?.item_count,
          total_price: cart?.total_price,
          items: (cart?.items || []).map((item) => ({
            key: item.key,
            quantity: item.quantity,
            final_line_price: item.final_line_price,
            properties: item.properties || {},
          })),
        });
      };

      const waitForCartToSettle = () => {
        const startedAt = Date.now();
        let lastSignature = '';
        let stableChecks = 0;

        return new Promise((resolve) => {
          const check = () => {
            fetchCart()
              .then((cart) => {
                const signature = getCartSignature(cart);
                stableChecks = signature === lastSignature ? stableChecks + 1 : 0;
                lastSignature = signature;

                if ((Date.now() - startedAt >= 1200 && stableChecks >= 2) || Date.now() - startedAt >= 5000) {
                  resolve(cart);
                  return;
                }

                window.setTimeout(check, 300);
              })
              .catch(() => {
                if (Date.now() - startedAt >= 5000) {
                  resolve(null);
                  return;
                }
                window.setTimeout(check, 500);
              });
          };

          check();
        });
      };

      const applyDiscountCode = async (code) => {
        if (!code) return null;

        const cart = await fetchCart();
        const existingCartCodes = (cart.discount_codes || [])
          .filter((discount) => discount?.applicable !== false)
          .map((discount) => discount?.code)
          .filter(Boolean);
        const activeOfferCodes = (cart.items || [])
          .map((item) => item?.properties?.['_qbk-discount-code'])
          .filter(Boolean);
        const codes = Array.from(new Set([...existingCartCodes, ...activeOfferCodes, code])).filter(Boolean);

        const body = JSON.stringify({ discount: codes.join(',') });

        const response = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body,
        });

        if (!response.ok) throw new Error('Unable to apply discount');
        return response.json();
      };

      const appendOfferProperties = (body, offer, triggerId) => {
        if (!offer) return body;

        const properties = {
          '_qbk-offer-id': offer.offerId,
          '_qbk-offer-type': offer.type,
          '_qbk-discount-code': offer.code,
        };

        if (triggerId) properties['_qbk-trigger-id'] = triggerId;

        if (body instanceof FormData || body instanceof URLSearchParams) {
          Object.entries(properties).forEach(([key, value]) => {
            body.set(`properties[${key}]`, value);
          });
          return body;
        }

        if (body && typeof body === 'object') {
          body.properties = { ...(body.properties || {}), ...properties };
        }

        return body;
      };

      const patchForms = async () => {
        const forms = document.querySelectorAll('#toner-flash-sale [data-tp-product-form]');
        let cart = null;

        for (const form of forms) {
          const variantId = getVariantIdFromForm(form);
          const offer = OFFER_BY_VARIANT[variantId];
          if (!offer) continue;

          form.dataset.tpTonerOfferCode = offer.code;
          form.dataset.tpTonerOfferId = offer.offerId;
          setHiddenInput(form, 'properties[_qbk-offer-id]', offer.offerId);
          setHiddenInput(form, 'properties[_qbk-offer-type]', offer.type);
          setHiddenInput(form, 'properties[_qbk-discount-code]', offer.code);

          try {
            if (!cart) cart = await fetchCart();
            const triggerItem = isEligibleCart(cart) ? findTriggerItem(cart) : null;
            if (triggerItem?.id) {
              setHiddenInput(form, 'properties[_qbk-trigger-id]', triggerItem.id);
            }
          } catch (_error) {
            // The submit handler will retry with fresh cart data.
          }
        }
      };

      const dispatchCartUpdated = (cart) => {
        const detail = { cart };
        document.dispatchEvent(new CustomEvent('seyoul:cart-updated', { detail }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
        window.dispatchEvent(new CustomEvent('cart:updated', { detail }));
      };

      const handleSubmit = async (event) => {
        const form = event.target?.closest?.('#toner-flash-sale [data-tp-product-form]');
        if (!form) return;

        const variantId = getVariantIdFromForm(form);
        const offer = OFFER_BY_VARIANT[variantId];
        if (!offer) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('[data-tp-atc-status]');
        const defaultLabel = button?.textContent || '';

        if (button) {
          button.disabled = true;
          button.textContent = 'กำลังเพิ่ม...';
        }

        if (status) status.textContent = '';

        try {
          const cartBeforeAdd = await fetchCart();
          const eligible = isEligibleCart(cartBeforeAdd);
          const triggerItem = eligible ? findTriggerItem(cartBeforeAdd) : null;

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', String(getQuantityFromForm(form)));
          appendOfferProperties(formData, offer, eligible ? triggerItem?.id : '');

          await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            body: formData,
          }).then((response) => {
            if (!response.ok) throw new Error('Unable to add item');
            return response.json();
          });

          const settledCart = (await waitForCartToSettle()) || (await fetchCart());
          const updatedCart = eligible ? await applyDiscountCode(offer.code) : settledCart;
          dispatchCartUpdated(updatedCart);
          if (eligible) {
            window.setTimeout(() => {
              applyDiscountCode(offer.code)
                .then((latestCart) => dispatchCartUpdated(latestCart))
                .catch(() => {});
            }, 1800);
          }

          if (button) button.textContent = button.dataset.successLabel || 'เพิ่มแล้ว ✓';
          if (status) {
            status.textContent = eligible
              ? `ใช้สิทธิ์ ${offer.code} แล้ว`
              : 'เพิ่มสินค้าแล้ว เมื่อยอดครบ ฿2,000 ระบบจะใช้สิทธิ์ ฿199';
          }

          setTimeout(() => {
            if (button) button.textContent = defaultLabel || button.dataset.defaultLabel || 'หยิบใส่ตะกร้า';
          }, 1800);
        } catch (error) {
          console.warn('[Seyoul] Toner Pad sale ATC failed', error);
          if (status) status.textContent = 'เพิ่มสินค้าไม่สำเร็จ กรุณาลองอีกครั้ง';
          if (button) button.textContent = defaultLabel || button.dataset.defaultLabel || 'หยิบใส่ตะกร้า';
        } finally {
          if (button) button.disabled = false;
        }
      };

      const patchFetch = () => {
        if (window.__seyoulTonerPadSaleFetchPatched) return;
        window.__seyoulTonerPadSaleFetchPatched = true;

        const nativeFetch = window.fetch;
        window.fetch = async (input, init = {}) => {
          try {
            const url = typeof input === 'string' ? input : input?.url;
            const isCartAdd = url && /\/cart\/add(\.js)?(?:\?|$)/.test(url);
            const body = init?.body;

            if (isCartAdd && body) {
              let workingBody = body;
              let variantId = '';

              if (body instanceof FormData || body instanceof URLSearchParams) {
                if (body instanceof FormData) {
                  workingBody = new FormData();
                  body.forEach((value, key) => workingBody.append(key, value));
                } else {
                  workingBody = new URLSearchParams(body);
                }
                variantId = String(workingBody.get('id') || '').trim();
              } else if (typeof body === 'string' && body.trim().startsWith('{')) {
                workingBody = JSON.parse(body);
                variantId = String(workingBody.id || '').trim();
              }

              const offer = OFFER_BY_VARIANT[variantId];
              if (offer) {
                const cart = await fetchCart();
                const triggerItem = isEligibleCart(cart) ? findTriggerItem(cart) : null;
                appendOfferProperties(workingBody, offer, triggerItem?.id || '');

                if (workingBody instanceof FormData || workingBody instanceof URLSearchParams) {
                  init = { ...init, body: workingBody };
                } else if (workingBody && typeof workingBody === 'object') {
                  init = {
                    ...init,
                    body: JSON.stringify(workingBody),
                    headers: {
                      ...(init.headers || {}),
                      'Content-Type': 'application/json',
                    },
                  };
                }
              }
            }
          } catch (error) {
            console.warn('[Seyoul] Toner Pad fetch patch skipped', error);
          }

          return nativeFetch.call(window, input, init);
        };
        window.fetch.__seyoulTonerPadQikifyFix = true;
      };

      patchFetch();
      document.addEventListener('submit', handleSubmit, true);
      document.addEventListener('DOMContentLoaded', patchForms);
      patchForms();
  })();
